/**
 * @module actions/collaboratingPartners
 */
import axios from 'axios'
import {
  API_URL,
  SET_COLLABORATING_PARTNERS
} from '../constants'

/**
 * @description Getting CollaboratingPartners from API and dispatching event
 * @return {Promise} Axios promise
 */
export function getCollaboratingPartners () {
  let url = API_URL + '/CollaboratingPartners/CollaboratingPartners'
  return dispatch => {
    return axios.get(url).then((res) => {
      dispatch({
        type: SET_COLLABORATING_PARTNERS,
        partnerList: res.data
      })
      return res
    })
  }
}

/**
 * @description Getting CollaboratingPartnerInvoiceSetting from API and dispatching event
 * @return {Promise} Axios promise
 */
export function getCollaboratingPartnerInvoiceSetting (parentPartnerId, partnerId) {
  let url = API_URL + '/CollaboratingPartners/PartnerInvoiceSetting/Get/'
  let data = {
    ParentPartnerShopId: parentPartnerId,
    PartnerShopId: partnerId
  }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Creating/saving PartnerInvoiceSetting
 * @return {Promise} Axios promise
 */
export function createSavePartnerInvoiceSetting (data) {
  let url = API_URL + '/CollaboratingPartners/PartnerInvoiceSetting/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/collaboratingPartners.js